module.exports = __webpack_public_path__ + "img/ico_hd_02.4a375611.png";